import { MenuItem, TextField, TextFieldProps, Tooltip, Typography } from '@mui/material';
import { L } from 'harmony-language';
import React from 'react';
import { useLocationTypes } from '../../../api/queries/use-location-types';
import { DynamicTranslate } from '../../../constants/constants';
import { LocationType } from '../../../types';

type SelectLocationTypeProps = TextFieldProps & {
    locationType: LocationType | null;
    handleChange: (locationType: LocationType) => void;
    filters?: {
        category?: string;
        cargoTypeId?: number;
        isBasedOnOrigin?: boolean;
    }
}

export const SelectLocationType = (props: SelectLocationTypeProps) => {
    const { locationType, handleChange, filters, ...rest } = props;
    const { data: locationTypes = [] } = useLocationTypes(filters);

    return (
        <TextField
            variant='standard'
            id='location-type'
            label={L.locationType()}
            select
            value={locationType?.id || ''}
            SelectProps={{
                MenuProps: {
                    MenuListProps: {
                        disablePadding: true
                    }
                }
            }}
            onChange={(e) => {
                const value = e.target.value;
                const locationType = locationTypes.find(l => l.id === Number(value))!;

                handleChange(locationType);
            }}
            {...rest}
        >
            {locationTypes.map(lt => {
                return (
                    <MenuItem key={lt.id} value={lt.id}>
                        <Tooltip
                            title={lt.cargoTypeCategories?.length && lt.cargoTypeCategories.map(c => DynamicTranslate(`cargoCategory${c}`)).join(', ')}
                            placement='right'
                            sx={{ width: '100%' }}
                        >
                            <Typography>{DynamicTranslate(`locationTypeValue${lt.id}`)}</Typography>
                        </Tooltip>
                    </MenuItem>
                );
            })}
        </TextField>
    );
};
